import React, { useState } from 'react'
import { createPortal } from 'react-dom'
import './weather/weather.css'
import './inter-fonts.css'

export const IFrame = ({
    children,
    ...props
}) => {
    const [contentRef, setContentRef] = useState(null)
    const mountNode =
        contentRef?.contentWindow?.document?.body

    return (
        <iframe {...props} ref={setContentRef}>
            {mountNode && createPortal(children, mountNode)}
        </iframe>
    )
}
